import React from "react";
import back from "../image/back.png";

const Accounting = () => {
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };
  return (
    <>
      <div className="bg-white rounded-lg">
        {/* Background Section */}
        <div
          className="bg-cover bg-center h-64 flex flex-col justify-center items-center text-center"
          style={{
            backgroundImage: `url(${back})`, // Replace with your image URL
          }}
        >
          <h1 className="text-2xl md:text-4xl font-bold text-blue-700">
            Accounting and Bookkeeping Services
          </h1>
          <p className="mt-2 text-black font-medium text-base md:text-lg px-4">
            Sanjay K Nathani & Co. offers comprehensive accounting and bookkeeping services designed to improve efficiency and organization in your financial management.
          </p>
        </div>

        {/* Description Section */}
        <div className="px-6 md:px-20 py-10">
          <p className="text-gray-700 leading-relaxed mb-6 text-sm md:text-base">
            The maintenance of accurate operational and financial information is essential for informed decision-making by investors, management, and governmental bodies. Accounting and bookkeeping services fulfill this crucial function and are also a legal requirement for all businesses to ensure timely tax payments and filings.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6 text-sm md:text-base">
            In today’s highly competitive business environment, access to up-to-date company statistics and information is essential for effective policy formulation by top and middle management. At Sanjay K Nathani & Co., we provide this crucial support through our comprehensive accounting and bookkeeping services, offering tailor-made systems for businesses of all sizes, from sole proprietorships to large conglomerates.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6 text-sm md:text-base">
            Sanjay K Nathani & Co. maintains a team of highly efficient and competent accountants and bookkeepers dedicated to meeting the critical data and information requirements of our clients. We provide accurate and timely services encompassing a full range of accounting, bookkeeping, quarterly updates, and financial statement preparation services, including:
          </p>

          {/* List of Services */}
          <ul className="list-disc list-inside space-y-2 text-gray-700 text-sm md:text-base">
            <li>Transactional activities like Data Entry, Invoices, Bank transactions, and more</li>
            <li>Book-Writing</li>
            <li>Daily Online Access and Timely Reporting Via The Internet</li>
            <li>Payroll Reconciliation</li>
            <li>Cash handling Services</li>
            <li>Preparing financial statements</li>
            <li>Trail balance Reconciliation</li>
            <li>Preparing Balance Sheet</li>
            <li>Checking Account Reconciliation</li>
            <li>Accounts Receivable/Payable Reconciliations</li>
            <li>Data Entry / Comparison of data from hard copy to soft copy and vice versa</li>
            <li>Capital Planning And Investment Management</li>
            <li>Preparation of Management Accounts and Statutory Accounts</li>
            <li>Investment Gain/Loss Accounting</li>
            <li>Partnership Accounting</li>
            <li>Co-Operative Societies Accounting</li>
            <li>Company’s Accounts Finalization</li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="mt-8 bg-gray-50 mx-6 md:mx-20 p-6 rounded-lg shadow-md">
          <h2 className="text-lg md:text-xl font-bold text-gray-800 mb-4">
            Get in Touch
          </h2>
          <p className="text-gray-600 mb-6 text-sm md:text-base">
            If you have any queries or questions, please reach out to us by clicking on the contact button below.
          </p>

          {/* Buttons */}
          <div className="flex flex-col md:flex-row gap-4">
            {/* Make Appointment Button */}
            <button onClick={handleAppointmentClick} className="px-6 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition duration-200 flex items-center justify-center gap-2 w-full md:w-auto">
              📅 Make Appointment
            </button>

            {/* Contact Us Button */}
            <button className="px-6 py-2 bg-[#005A8C] text-white rounded  transition duration-200 flex items-center justify-center gap-2 w-full md:w-auto">
              📧 Contact Us
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Accounting;
